import { render } from "./PerformerAlias.vue?vue&type=template&id=0e3db9b4&ts=true"
import script from "./PerformerAlias.vue?vue&type=script&lang=ts"
export * from "./PerformerAlias.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__